import BaseService from '../BaseService'

class ProductResearchservice extends BaseService {
    constructor() {
        super('/product-research');
    }
}

export default new ProductResearchservice()
